// extracted by mini-css-extract-plugin
export default {"details":"styles_details__tM3yp","field":"styles_field__zhX9l","fields":"styles_fields__HycX-","form":"styles_form__C+whw"};